var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.getCurrentCustomer.message
    ? _c(
        "div",
        {
          staticClass: "d-flex column align-items-center",
          staticStyle: { gap: "10px" },
        },
        [
          _vm.isTefCustomerDocumentWaiting
            ? _c("b-spinner", { attrs: { small: "" } })
            : _vm._e(),
          _c("p", { staticClass: "mb-0 font-weight-bold" }, [
            _c("b", [_vm._v("Cliente: ")]),
            _c("span", { class: _vm.getCurrentCustomer.class }, [
              _vm._v(_vm._s(_vm.$t(_vm.getCurrentCustomer.message))),
            ]),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }